"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CancelActionMarker = require("../../change/CancelActionMarker");

var _Types = _interopRequireDefault(require("../../types/Types"));

var _prepUpdater = _interopRequireDefault(require("../../parcelData/prepUpdater"));

var _setMetaDefault = _interopRequireDefault(require("../../parcelData/setMetaDefault"));

var _shouldDangerouslyUpdateParcelData = _interopRequireDefault(require("../../parcelData/shouldDangerouslyUpdateParcelData"));

var _HashString = _interopRequireDefault(require("../../util/HashString"));

var _filterNot = _interopRequireDefault(require("unmutable/lib/filterNot"));

var _has = _interopRequireDefault(require("unmutable/lib/has"));

var _pipeWith = _interopRequireDefault(require("unmutable/lib/util/pipeWith"));

var HashFunction = function HashFunction(fn) {
  return "".concat((0, _HashString.default)(fn.toString()));
};

var _default = function _default(_this) {
  return {
    _pushModifierId: function _pushModifierId(prefix, updater) {
      var id = (0, _shouldDangerouslyUpdateParcelData.default)(updater) ? "s".concat(HashFunction(updater._updater || updater)) : HashFunction(updater);
      return _this._id.pushModifier("".concat(prefix, "-").concat(id));
    },
    modifyDown: function modifyDown(updater) {
      (0, _Types.default)("modifyDown()", "updater", "function")(updater);
      var parcelDataUpdater = (0, _prepUpdater.default)(updater);
      return _this._create({
        id: _this._methods._pushModifierId('md', updater),
        parcelData: parcelDataUpdater(_this._parcelData),
        updateChangeRequestOnDispatch: function updateChangeRequestOnDispatch(changeRequest) {
          return changeRequest._addStep({
            type: 'md',
            updater: parcelDataUpdater
          });
        }
      });
    },
    modifyUp: function modifyUp(updater) {
      (0, _Types.default)("modifyUp()", "updater", "function")(updater);

      var parcelDataUpdater = function parcelDataUpdater(parcelData, changeRequest) {
        var nextData = (0, _prepUpdater.default)(updater)(parcelData, changeRequest);
        return (0, _CancelActionMarker.checkCancellation)(nextData);
      };

      return _this._create({
        id: _this._methods._pushModifierId('mu', updater),
        updateChangeRequestOnDispatch: function updateChangeRequestOnDispatch(changeRequest) {
          return changeRequest._addStep({
            type: 'mu',
            updater: parcelDataUpdater,
            changeRequest: changeRequest
          });
        }
      });
    },
    initialMeta: function initialMeta(_initialMeta) {
      (0, _Types.default)("initialMeta()", "initialMeta", "object")(_initialMeta);
      var meta = _this._parcelData.meta;
      var parcelDataUpdater = (0, _pipeWith.default)(_initialMeta, (0, _filterNot.default)(function (value, key) {
        return (0, _has.default)(key)(meta);
      }), _setMetaDefault.default);
      return _this._create({
        id: _this._id.pushModifier('im'),
        parcelData: parcelDataUpdater(_this._parcelData),
        updateChangeRequestOnDispatch: function updateChangeRequestOnDispatch(changeRequest) {
          return changeRequest._addStep({
            type: 'mu',
            updater: parcelDataUpdater,
            changeRequest: changeRequest
          });
        }
      });
    }
  };
};

exports.default = _default;